import {connect} from 'react-redux';
import {Courses} from './Courses.js';
import {setCourseStatus} from '../../redux/actions/action-creators.js';
import {getFromLocalStorage} from "../../utility/utility";
import {LOGIN} from "../../redux/actions/action-types";
import {database} from "../../firebase";



const getCourseStatuses = (coursesStatuses) => {
  const ts = Math.round((new Date()).getTime() / 1000);
  const userId = getFromLocalStorage(LOGIN.SUCCESS);
  database.ref('/users/' + userId + '/status').update({
    lastAccess: ts,
  });
  return coursesStatuses;
};


const getResources = ({status, data}) => {
  return {
    loaded: status === 'loaded' ? true : false,
    data: data,
  };
};

const mapStateToProps = (state) => ({
  coursesStatuses: getCourseStatuses(state.coursesStatuses),
  resources: getResources(state.resources),
  language: state.status.language,
  email: state.status.email,
  firstName: state.status.firstName,
  country: state.status.country,
  lastName: state.status.lastName,
  company: state.status.company,
  id: state.status.id,
});

const mapDispatchToProps = (dispatch) => ({
  onClick: (status, course) => {
    dispatch(setCourseStatus({status, course}));
  },
});

const UpdatedCourses = connect(
  mapStateToProps,
  mapDispatchToProps
)(Courses);

export default UpdatedCourses;


// WEBPACK FOOTER //
// ./src/components/Courses/CoursesContainer.js